import { StyleSheet } from "react-native";

export default StyleSheet.create({
  cardVaga: {
    width: 220,
    marginRight: 10,
    padding: 10,
    

    backgroundColor: "#5555",

    borderRadius: 5,

    marginVertical: 2,
    shadowColor: "#0005",
    shadowOffset: {
      width: 4,
      height: 0
    },
    shadowRadius: 5,
  },
});
